import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { LocalStorageService } from "../../shared/local-storage.service";
import { AppConfig, AppConfigType } from "../../shared/models/appConfig.model";
import { DrawerComponent, DrawerItem, DrawerModule, DrawerSelectEvent } from "@progress/kendo-angular-layout";
import {
    eyeIcon,
    wrenchIcon,
    fileExcelIcon,
    clockIcon,
    planeSolidIcon,
    fileTxtIcon,
    tellAFriendBoxIcon,
    alignItemsStartIcon,
    planeOutlineIcon,
    fileAscxIcon,
    usersSolidIcon,
    planeIcon,
} from "@progress/kendo-svg-icons";
import { Router } from "@angular/router";

@Component({
    selector: "app-sidenav",
    templateUrl: "./sidenav.component.html",
    styleUrl: "./sidenav.component.scss",
    standalone: false,
})
export class SidenavComponent implements OnInit {
    public userSessionObject;

    public passengersConfig: AppConfig;
    public dailyCheckConfig: AppConfig;
    public aircraftActivityConfig: AppConfig;
    public pilotActivityConfig: AppConfig;

    public showPilotHours: boolean = false;

    public menuItems;

    public expanded: boolean = false;

    @ViewChild("drawer", { static: false }) drawer: DrawerComponent;

    @HostListener("mouseenter")
    onMouseEnter() {
        this.drawer.toggle(true);
    }

    @HostListener("mouseleave")
    onMouseLeave() {
        this.drawer.toggle(false);
    }

    constructor(
        private _localStorageService: LocalStorageService,
        private _router: Router,
    ) {}

    ngOnInit(): void {
        this.userSessionObject = this._localStorageService.getUserLocalStorageObject();
        this.passengersConfig = this.userSessionObject.appConfigs.find((config) => config.type === AppConfigType.passengers);
        this.dailyCheckConfig = this.userSessionObject.appConfigs.find((config) => config.type === AppConfigType.dailyCheck);
        this.aircraftActivityConfig = this.userSessionObject.appConfigs.find((config) => config.type === AppConfigType.aircraftActivityList);
        this.pilotActivityConfig = this.userSessionObject.appConfigs.find((config) => config.type === AppConfigType.pilotActivityList);
        this.showPilotHours = this.userSessionObject.showPilotHourLimits;

        this.menuItems = [
            {
                text: "Aircraft Data",
                svgIcon: planeOutlineIcon,
                routerLink: "/aircrafts",
            },
            {
                text: "ATL List",
                svgIcon: fileTxtIcon,
                routerLink: "/atl",
            },
            {
                text: "Passengers",
                svgIcon: tellAFriendBoxIcon,
                routerLink: "/passengers",
                hidden: this.userSessionObject.organizationId !== 2,
            },
            {
                text: "Statistic Pilots Hours",
                svgIcon: alignItemsStartIcon,
                routerLink: "/statistic-pilot-hours",
                hidden: !this.showPilotHours,
            },
            {
                text: "Flights",
                svgIcon: planeIcon,
                routerLink: "/flights2",
            },
            {
                text: "Completed Flights",
                svgIcon: planeSolidIcon,
                routerLink: "/flights",
            },
            {
                text: "Export Flights Data",
                svgIcon: fileExcelIcon,
                routerLink: "/export",
            },
            {
                text: "Aircraft Activity",
                svgIcon: fileAscxIcon,
                routerLink: "/aircraft-activity",
                hidden: !this.aircraftActivityConfig?.enabled,
            },
            {
                text: "Pilot Activity",
                svgIcon: usersSolidIcon,
                routerLink: "/pilot-activity",
                hidden: !this.pilotActivityConfig?.enabled,
            },
            {
                text: "Next Due Maintenances",
                svgIcon: eyeIcon,
                routerLink: "/next-due-maintenances",
            },
            {
                text: "Hold Item Lists",
                svgIcon: wrenchIcon,
                routerLink: "/hold-item-list",
            },
            {
                text: "Daily Checks",
                svgIcon: clockIcon,
                routerLink: "/daily-checks",
                hidden: !this.dailyCheckConfig.enabled,
            },
        ];

        this.menuItems = this.menuItems.filter((item) => !item.hidden);
    }
}
